export default function () {
    return {
        token: null,
        user: null,
        enums:{},
        enumsLV:{},
        enumsObjs:{},
        menu:[],
        errorLogin: false,
        titleScreen:'',
        showLoading: false,
        name: 'eProtocolo',
        companyDeveloper: 'MczSoft',
        tokenPainel:'',
        empresaDest:{},
        multitenancy:true
    }
  }
  
